// CSS
import "./tag-chip.css";

export function TagChip(props) {
    if (!props.Name) {
        return null;
    }

    return (
        <span className="eone-ui-tag-chip" title={props.Title ?? props.Name} data-testid={props.DataTestId}>
            {props.HexColor && (
                <span
                    className="eone-ui-tag-chip-dot"
                    style={{ backgroundColor: `#${props.HexColor}` }} />
            )}
            {props.Name}
        </span>
    );
}

export function TagChipList(props) {
    const tags = Array.isArray(props.Tags) ? props.Tags : [];
    if (tags.length === 0) {
        return null;
    }

    return (
        <span className="eone-ui-tag-chip-list">
            {tags.map(tag => (
                <TagChip key={tag.TagId} Name={tag.Name} HexColor={tag.HexColor} />
            ))}
        </span>
    );
}
